import { Injectable } from '@angular/core';
import { GenericUtilityService } from '../generic/generic-utility.service';
import { PatientPersonalInfo } from '../models/verifypatient/verifypatient';

@Injectable({
  providedIn: 'root'
})
export class PastSurgicalService {

  constructor(private genericService: GenericUtilityService) { }

  getPastSurgicalHistory(PatientAccount: any, PracticeCode: any) {
    return this.genericService.ApiGetMethodTalkphr("TalkCheckin/GetPastSurgicalHistory?PatientAccount=" + PatientAccount + '&PracticeCode=' + PracticeCode);
  }

  getPastSurgProcedures(personalInfo: PatientPersonalInfo) {
    return this.genericService.ApiGetMethodTalkphr("TalkCheckin/getPastSurgProcedures?PatientAccount=" + personalInfo.PATIENT_ACCOUNT + '&PracticeCode=' + personalInfo.PRACTICE_CODE);
  }

  getSurgPlaces(personalInfo: PatientPersonalInfo) {
    return this.genericService.ApiGetMethodTalkphr("TalkCheckin/getSurgPlaces?PatientAccount=" + personalInfo.PATIENT_ACCOUNT + '&PracticeCode=' + personalInfo.PRACTICE_CODE);
  }

  getSurgComplications(personalInfo: PatientPersonalInfo) {
    return this.genericService.ApiGetMethodTalkphr("TalkCheckin/getSurgComplications?PatientAccount=" + personalInfo.PATIENT_ACCOUNT + '&PracticeCode=' + personalInfo.PRACTICE_CODE);
  }

  SaveUpdatePastSurgicalHistory(data: any) {
    return this.genericService.ApiPostMethodTalkphr("TalkCheckin", "SaveUpdatePastSurgicalHistory", data);
  }

  deletePastSurgicalHistory(data: any) {
    return this.genericService.ApiPostMethodTalkphr("TalkCheckin", "DeletePastSurgicalHistory", data);
  }

  noKnownPastHospHistory(PatientAccount: any, PracticeCode: any) {
    return this.genericService.ApiPostMethodTalkphr("TalkCheckin", "SetNoKnownPastSurgicalForPatient", { PatientAccount: PatientAccount, PracticeCode: PracticeCode });
  }
}
